import { render } from "./NewDashboardAdmin.vue?vue&type=template&id=4ea2c984&scoped=true"
import script from "./NewDashboardAdmin.vue?vue&type=script&lang=js"
export * from "./NewDashboardAdmin.vue?vue&type=script&lang=js"

import "./NewDashboardAdmin.vue?vue&type=style&index=0&id=4ea2c984&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea2c984"]])

export default __exports__